import { ListEditor } from "../../components/list-editor";
import React from "react";
import { array, string, object } from 'yup';
import {
    PosterSize,
    SiteStructure, SiteStructureQueryQuery,
    useSiteStructureQueryQuery, useSiteStructuresMutationMutation
} from "../../generated/graphql";
import { Tooltip } from "@mui/material";
import { PosterSizeSelect } from "../../components/MaterialSelects/PosterSizeSelect";
import { FieldTableTitleTooltip } from "../../components/FieldTable/FieldTableTitleTooltip";
import { useLocation } from "react-router";
import { uniqueId } from "../../utils";
import { SiteStructureGroupSelect } from "../../components/MaterialSelects/SiteStructureGroupSelect";


const columns = [{
    header: 'Name',
    accessor: 'name',
    dataType: 'text'
}, {
    header: <Tooltip title={<>When a full panel is booked for a site, this is the poster size allocated to the booking<br />
        For panels which are restricted to only allow slot bookings, this is instead the size allocated to a slot booking.</>}><FieldTableTitleTooltip>Poster Size</FieldTableTitleTooltip></Tooltip>,
    accessor: 'posterSize',
    sort: 'posterSize.name',
    dataType: 'select',
    options: {
        label: 'name',
        renderEditor: ({ field }) => <PosterSizeSelect {...field} autoFocus={true} isPanelPoster={true} />
    }
}, {
    header: <Tooltip title={<>When a slot is booked on a panel at this site, this is the basic poster size<br />
        i.e. '60x40' for a site with 2 posters per slot will create use a 2x60x40 poster size.  Always pick a poster size with quantity 1.</>}><FieldTableTitleTooltip>Slot Poster Size</FieldTableTitleTooltip></Tooltip>,
    accessor: 'slotPosterSize',
    sort: 'slotPosterSize.name',
    dataType: 'select',
    filterValue:(v:any)=>{
        return v?{name:v.name,id:v.id,__typename:v.__typename}:v;
    },
    options: {
        label: 'name',
        renderEditor: ({ field }) => <PosterSizeSelect {...field} autoFocus={true} isPanelPoster={true} allowBlank={true} />
    }
}, {
    header: 'Groups',
    accessor: 'siteStructureGroup',
    dataType: 'select',
    options: {
        label: 'name',
        renderEditor: ({ field }) => <SiteStructureGroupSelect {...field} autoFocus={true} />
    }
}
];

function newRow(): SiteStructure {
    return ({
        id: uniqueId(),
        name: '',
        posterSize: null,
        siteStructureGroup: null
    })
}

const schema = array().of(object().shape({
    name: string().min(1),
    posterSize: object().required(),
}));

const relationships = {
    posterSize: 'connect',
    siteStructureGroup: 'connect',
    slotPosterSize: 'connect'
};

function getValues(data: SiteStructureQueryQuery) {
    return data?.siteStructures??[];
}

const SiteStructures = () => {
    const query = useSiteStructureQueryQuery();
    const [mutation, mutationResult] = useSiteStructuresMutationMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
            columns={columns}
            validationSchema={schema}
            title="Site Structures"
            permission="sites"
            query={query}
            mutation={mutation}
            relationships={relationships}
            saveResult={mutationResult}
            newRow={newRow}
            newRowLabel="Add Site Structure"
            baseUrl={url}
            className="site-structures"
            getValues={getValues}
        />);
}

export default SiteStructures;
